import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import GuestRoomExperienceRoomTabDigitalDoorLock from '../../../../../../../components/guest-room-experience-room-tabs/guest-room-experience-room-tab-digital-door-lock/Guest-Room-Experience-Room-Tab-Digital-Door-Lock';
import GuestRoomExperienceRoomTabDND from '../../../../../../../components/guest-room-experience-room-tabs/guest-room-experience-room-tab-dnd/Guest-Room-Experience-Room-Tab-DND';
import GuestRoomExperienceRoomTabDoorCamera from '../../../../../../../components/guest-room-experience-room-tabs/guest-room-experience-room-tab-door-camera/Guest-Room-Experience-Room-Tab-Door-Camera';
import GuestRoomExperienceRoomTabDoorLock from '../../../../../../../components/guest-room-experience-room-tabs/guest-room-experience-room-tab-door-lock/Guest-Room-Experience-Room-Tab-Door-Lock';
import GuestRoomExperienceRoomTabMMR from '../../../../../../../components/guest-room-experience-room-tabs/guest-room-experience-room-tab-mmr/Guest-Room-Experience-Room-Tab-MMR';
import GuestRoomExperienceRoomTabRoomArea from '../../../../../../../components/guest-room-experience-room-tabs/guest-room-experience-room-tab-room-area/Guest-Room-Experience-Room-Tab-Room-Area';
import {
  GUEST_ROOM_EXPERIENCE_ROOM,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_DIGITAL_DOOR_LOCK,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_DND,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_CAMERA,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_MMR,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA,
} from '../../../../../../../constants/GuestRoomExperienceConst';
import {
  greRoomsConfigurationDetails,
  greTemplatesSelector,
} from '../../../../../configurationSlice';
const useStyles = makeStyles((theme) => ({
  activeButton: {
    // color: "#29E67C",
    margin: '5px !important',
    borderRadius: '5px !important',
    borderBottom: '4px solid #74E287',
    opacity: 1,
    minWidth: '140px',
    fontWeight: 600,
    fontSize: '16px',
    padding: '3px',
  },
  button: {
    border: '1px solid #999999',
    margin: '5px !important',
    borderRadius: '5px !important',
    minWidth: '140px',
    fontWeight: 600,
    fontSize: '16px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  input: {
    display: 'none',
  },
}));

const GuestRoomExperienceRoomView = (props) => {
  const { room, onViewToggle, onBack, showLoader = () => {} } = props;
  const [activeTab, setActiveTab] = useState(GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA);
  const selectedRoom = useSelector(greRoomsConfigurationDetails);
  const originalTemplates = useSelector(greTemplatesSelector);

  const isCameraEnabled = () => {
    return originalTemplates.find((template) => template.id === selectedRoom.templateId)
      ?.doorCameraEnabled;
  };
  const classes = useStyles();

  return (
    <>
      <div className='template-view'>
        <div className='mt-5 row mx-0'>
          <div className='col-md-6 px-0 d-flex align-items-center'>
            <Button
              variant='text'
              color='secondary'
              size='small'
              startIcon={<ArrowBack />}
              onClick={(e) => {
                onBack(GUEST_ROOM_EXPERIENCE_ROOM);
                onViewToggle(false, null);
              }}
              className='me-2'
            >
              Back
            </Button>
            <span className='page-title'>Room {selectedRoom.roomId}</span>
          </div>
        </div>
        <div className='card px-5 shadow mt-4 mx-3 mb-4 h-100'>
          <div className='row d-flex mt-4 guest-room-list mx-3 mb-3'>
            <div className='col-md-12'>
              <span className='page-title-ternary-label'>Template: </span>
              <span className='page-title-ternary-value'>{room.templateName}</span>
            </div>

            <div className='d-flex'>
              <Button
                size='large'
                variant={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA ? 'outlined' : 'text'
                }
                className={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA
                    ? classes.activeButton
                    : classes.button
                }
                onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA)}
              >
                Room Area
              </Button>
              <Button
                size='large'
                variant={activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DND ? 'outlined' : 'text'}
                className={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DND
                    ? classes.activeButton
                    : classes.button
                }
                onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_ROOM_TAB_DND)}
                style={{ minWidth: '100px' }}
              >
                DND
              </Button>
              <Button
                size='large'
                variant={activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_MMR ? 'outlined' : 'text'}
                className={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_MMR
                    ? classes.activeButton
                    : classes.button
                }
                onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_ROOM_TAB_MMR)}
                style={{ minWidth: '100px' }}
              >
                MMR
              </Button>
              <Button
                size='large'
                variant={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DIGITAL_DOOR_LOCK
                    ? 'outlined'
                    : 'text'
                }
                className={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DIGITAL_DOOR_LOCK
                    ? classes.activeButton
                    : classes.button
                }
                onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_ROOM_TAB_DIGITAL_DOOR_LOCK)}
                style={{ minWidth: '180px' }}
              >
                Digital Door Key
              </Button>
              <Button
                size='large'
                variant={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK ? 'outlined' : 'text'
                }
                className={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK
                    ? classes.activeButton
                    : classes.button
                }
                onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK)}
                style={{ minWidth: '125px' }}
              >
                Door Lock
              </Button>

              {isCameraEnabled() && (
                <Button
                  size='large'
                  variant={
                    activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_CAMERA ? 'outlined' : 'text'
                  }
                  className={
                    activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_CAMERA
                      ? classes.activeButton
                      : classes.button
                  }
                  onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_CAMERA)}
                  style={{ minWidth: '145px' }}
                >
                  Door Camera
                </Button>
              )}
            </div>
          </div>
          <div className='row mx-2 d-flex mt-2 gre-content-area'>
            {activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA && (
              <GuestRoomExperienceRoomTabRoomArea
                areaInfo={selectedRoom.areas}
                roomId={selectedRoom.roomId}
                showLoader={showLoader}
              />
            )}
            {activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DND && (
              <GuestRoomExperienceRoomTabDND
                typeDndInfo={selectedRoom.dnd}
                roomId={selectedRoom.roomId}
                showLoader={showLoader}
              />
            )}
            {activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_MMR && (
              <GuestRoomExperienceRoomTabMMR
                mmrInfo={selectedRoom.mmr}
                roomId={selectedRoom.roomId}
                showLoader={showLoader}
              />
            )}
            {activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DIGITAL_DOOR_LOCK && (
              <GuestRoomExperienceRoomTabDigitalDoorLock
                ddkInfo={selectedRoom.ddk}
                roomId={selectedRoom.roomId}
                showLoader={showLoader}
              />
            )}
            {activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_CAMERA && (
              <GuestRoomExperienceRoomTabDoorCamera
                dcInfo={selectedRoom?.dc}
                roomId={selectedRoom.roomId}
                showLoader={showLoader}
              />
            )}
            {activeTab === GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK && (
              <GuestRoomExperienceRoomTabDoorLock
                doorLockInfo={selectedRoom?.doorLock}
                roomId={selectedRoom.roomId}
                showLoader={showLoader}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GuestRoomExperienceRoomView;
